/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Note_Filter_From_DateInputs */

const vi_sl_note_filter_from_date = /** @type {(inputs: Sl_Note_Filter_From_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ ngày`)
};

/**

* @param {Sl_Note_Filter_From_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_note_filter_from_date = /** @type {((inputs?: Sl_Note_Filter_From_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Note_Filter_From_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_note_filter_from_date(inputs)
});